import { render, staticRenderFns } from "./AccettazioneSsnAnagraficaComponentN.vue?vue&type=template&id=73186957&scoped=true"
import script from "./AccettazioneSsnAnagraficaComponentN.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnAnagraficaComponentN.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnAnagraficaComponentN.vue?vue&type=style&index=0&id=73186957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73186957",
  null
  
)

export default component.exports